export const PaymentLimitExceededRptConstants = {
    GETALL_REQUEST: 'PAYMENT_LIMIT_EXCEEDED_GETALL_REQUEST',
    GETALL_SUCCESS: 'PAYMENT_LIMIT_EXCEEDED_GETALL_SUCCESS',
    GETALL_FAILURE: 'PAYMENT_LIMIT_EXCEEDED_GETALL_FAILURE',

    GETEXPORT_REQUEST: 'PAYMENT_LIMIT_EXCEEDED_GETEXPORT_REQUEST',
    GETEXPORT_SUCCESS: 'PAYMENT_LIMIT_EXCEEDED_GETEXPORT_SUCCESS',
    GETEXPORT_FAILURE: 'PAYMENT_LIMIT_EXCEEDED_GETEXPORT_FAILURE',

    LOADING_REQUEST: 'PAYMENT_LIMIT_EXCEEDED_LOADING_REQUEST'
}
